import apiPostRequest from "./base/api-post-request";

const userAuthMicrosoft = (accessToken, tenant) =>
  apiPostRequest("/auth/microsoft")({
    accessToken,
    tenant,
  });

export default userAuthMicrosoft;
